module.exports = __webpack_public_path__ + "static/media/bg3.25a43d12.jpeg";